export type QueryParams = Record<string, string | number | boolean | Date>

const queryStringBuilder = (obj: QueryParams): string => {
  const queryString = Object.entries(obj)
    .map((param) => {
      return `${param[0]}=${param[1]}`
    })
    .join('&')

  const params = new URLSearchParams(queryString)

  ;[...(params.entries() as any)].forEach(([key, value]) => {
    if (!value || typeof value === 'undefined') {
      params.delete(key)
    }
  })

  const query = String(params)

  return `?${query}`
}

export default queryStringBuilder
